import { Builder_, Dates_, Dropdown_, Slider_ } from 'monica-alexandria';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Notify_Slider_Action from '../notify/Notify_Slider_Action';
import { format_date } from '../../../../../../helpers/DateFormatter';
import { map_messages } from '../../utils/MapMessages';
import { useNavigate } from 'react-router-dom';
import i18n from '../../../../../../localization/i18next';

const EditReportDates = styled.div`
    
`

export default function Edit_Report_Dates(props) {
    const [showButton, setShowButton] = useState(true); 

    const lang = i18n.language ? i18n.language : 'en';

    const navigate = useNavigate()

    // this state helps us what to render in the initial load, value: 'dates'|'conformation'|'question'
    const [showHelper, setShowHelper] = useState('dates');
    const { t } = useTranslation();


    const [dateRange, setDateRange] = useState({
        minDate: null,
        maxDate: new Date(),
    });
    const initialState = !props.initLoad
    ? [props.dateFrom ? new Date(props.dateFrom).toISOString() : '', props.dateTo ? new Date(props.dateTo).toISOString() : '']
    : ["", ""];

    // state the secures the user has set dates
    const [validDateState, setValidDateState] = useState(true);
    const [renderedDates, setRenderedDates] = useState(initialState);
  

    const acceptableRange = props.acceptableRange || 1000;

    const formatDate = (date) => {
        const localeDateFormat = new Intl.DateTimeFormat().formatToParts(new Date());

        const dateFormat = localeDateFormat
            .map((part) => {
                if (part.type === 'day') {
                    return 'dd';
                } else if (part.type === 'month') {
                    return 'mm';
                } else if (part.type === 'year') {
                    return 'yyyy';
                }
                return part.value;
            })
            .join('/');

        let format = dateFormat.split('//');

        let dateParts = date.toLocaleDateString().split('/');
        let formattedDate = [];

        let indexes = { month: -1, day: -1, year: -1 };
        let counter = 0;
        for (let part of format) {
            if (part.includes('dd')) indexes.day = counter;
            if (part.includes('mm')) indexes.month = counter;
            if (part.includes('yyyy')) indexes.year = counter;
            counter++;
        }

        formattedDate.push(dateParts[indexes.year]);
        formattedDate.push(dateParts[indexes.month] && dateParts[indexes.month].length > 1 ? dateParts[indexes.month] : `0${dateParts[indexes.month]}`);
        formattedDate.push(dateParts[indexes.day] && dateParts[indexes.day].length > 1 ? dateParts[indexes.day] : `0${dateParts[indexes.day]}`);

        return formattedDate?.length > 0 ? formattedDate.join('-') : '';
    };

    const handleDateRanges = (selections) => {
        const earlierDate = new Date(selections[0].getTime() - acceptableRange * 24 * 60 * 60 * 1000);
        const laterDate = new Date(selections[0].getTime() + acceptableRange * 24 * 60 * 60 * 1000);
        setDateRange({
            minDate: earlierDate,
            maxDate: laterDate < new Date() ? laterDate : new Date(),
        });
    };

    const onChange = (selections) => {
        if (selections[0] && selections[0] !== null && selections[1] && selections[1] !== null) {
            setRenderedDates(selections);
            if (selections.length === 2)
                props.onDates({
                    dateFrom: formatDate(selections[0]),
                    dateTo: formatDate(selections[1]),
                });
            setDateRange({
                minDate: null,
                maxDate: new Date(),
            });
        } else {
            handleDateRanges(selections);
            props.onDates({
                dateFrom: formatDate(selections[0]),
                dateTo: formatDate(selections[0]),
            });
        }
    };
    const onDone = () => {
        if(props.initLoad){
            setShowHelper('conformation');
            setShowButton(false)
        }
        else
            props.onClick();
    }


    //user action to determine conformation messages
    const [status, setStatus] = useState(props.confStatus);
    const [info, setInfo] = useState({
        title:'',
        text:'', 
        main:'',
        red: '', 
        img:''
    });

    

    useEffect(() => {
        if(props.initLoad ) {
            setStatus(props.confStatus);
            const obj = map_messages('dates', status, props.dateFrom, props.dateTo, t, props.business, props.adAccount, props.fbPage, props.instaPage, props.flow);
            setInfo(prevInfo => ({
                ...prevInfo,
                title: obj?.title,
                text: obj?.text,
                main: obj?.main,
                red: obj?.red,
                img: obj?.img
            }));
        }
    }, [props, status]);

    useEffect(() => {
        // if dates are valid then enable the button to proceed
        if(renderedDates[0] !== "" && renderedDates[1] !== "")
            setValidDateState(false)
    }, [renderedDates]);
      

    const onGrey = () => {
        if(props.initLoad) {
            navigate(`/${lang}/meta/report-template`)
        }
        else {
            props.onClick();
        }
    }
    return (
    
        // TODO: maybe create a new component?
        
        <>
        { showButton ? (
            // ON EDIT
            <Slider_ onGrey={onGrey} iconGreyLeft="Back" grey={t("Back")} onClick={() => onDone()} title={t('Report period')} text={t("Set period")} disabled={validDateState}>
                <EditReportDates>
                    <Builder_ title={t('Set the report date range')}>
                        <Dates_ allowPartialRange={true} selectRange={true} dateFullCellRender={(date) => date.date()} onChange={onChange} value={renderedDates} minDate={dateRange.minDate} maxDate={dateRange.maxDate} />
                    </Builder_>
                    <Builder_ title={t('Set date format')}>
                        <Dropdown_>
                            <select onChange={props.onDateFormat}>
                                <option selected={props.currentFormat === 'YYYY-MM-DD'} value={'YYYY-MM-DD'}>
                                    {t("YYYY/MM/DD")}
                                </option>
                                <option selected={props.currentFormat === 'DD-MM-YYYY'} value={'DD-MM-YYYY'}>
                                    {t("DD/MM/YYYY")}
                                </option>
                                <option selected={props.currentFormat === 'MM-DD-YYYY'} value={'MM-DD-YYYY'}>
                                    {t("MM/DD/YYYY")}
                                </option>
                            </select>
                        </Dropdown_>
                    </Builder_>
                </EditReportDates>
            </Slider_>
            ) 
            : 
            (
            // WIZARD
            <Slider_    title={t('Report period')} onClick={() => {props.onClick(); props.changeConformationStatus(true)}} icon="Next" text={info.main}>
                {showHelper === 'dates' ? 
                <EditReportDates>
                    <Builder_ title={t('Set the report date range')}>
                        <Dates_ allowPartialRange={true} selectRange={true} dateFullCellRender={(date) => date.date()} onChange={onChange} value={renderedDates} minDate={dateRange.minDate} maxDate={dateRange.maxDate} />
                    </Builder_>
                    <Builder_ title={t('Set date format')}>
                        <Dropdown_>
                            <select onChange={props.onDateFormat}>
                                <option selected={props.currentFormat === 'YYYY-MM-DD'} value={'YYYY-MM-DD'}>
                                    {t("YYYY/MM/DD")}
                                </option>
                                <option selected={props.currentFormat === 'DD-MM-YYYY'} value={'DD-MM-YYYY'}>
                                    {t("DD/MM/YYYY")}
                                </option>
                                <option selected={props.currentFormat === 'MM-DD-YYYY'} value={'MM-DD-YYYY'}>
                                    {t("MM/DD/YYYY")}
                                </option>
                            </select>
                        </Dropdown_>
                    </Builder_>
                </EditReportDates>
                : null
                }
 
                {showHelper === 'conformation' ?
        
                <Notify_Slider_Action 
                    title={info?.title}
                    text={info?.text} 
                    textMain={info?.main}
                    textRed={info?.red}
                    img={info?.img}
                    onClickGrey={()=> {setShowHelper('dates'); setShowButton(true);}}
                    onRed={() => {props.skipSection();  props.changeConformationStatus(false)}}  
                />
                : null
                }
                {/* TODO: here change the messaged base on the NEXT SECTION-NOT JUST META
                I.E.: Find the next section and compute the index of it 
                */}
               
            </Slider_>
            )
        }
        </>
    );
}
